import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CompanyConfigFacade } from './+state';
import { CompanyConfigStateModule } from './+state/company-config.state.module';

import {
  CompanyConfigService
} from './services';
import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';

@NgModule({
  imports: [CommonModule, CompanyConfigStateModule],
})
export class DomainCompanyConfigModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainCompanyConfigModule,
      providers: [
        CompanyConfigService,
        AppConfiguration,
        CompanyConfigFacade
      ],
    };
  }
}
